<template>
  <gg-card>
    <gg-card-header>
      Change Password
    </gg-card-header>
    <gg-card-text>
      <change-password-form />
    </gg-card-text>
  </gg-card>
</template>

<script>
import ChangePasswordForm from '@/components/Profile/ChangePasswordForm'

export default {
  name: 'ChangePasswordCard',
  components: {
    ChangePasswordForm,
  }
}
</script>
